/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import Avatar from './Avatar';
import team2 from '../../assets/img/team/avatar.svg';
import UserProfileCardSection from './UserProfileCardSection';
import { copy } from './Common';
const UserProfileTopSection = ({ data, pageLanguageContent, showCardSection }) => {
	useEffect(() => {
		if (data) {
		}
		// eslint-disable-next-line
	}, [data]);

	/* function to copy content*/
	function copyContent(content) {
		copy(content);
	}

	return (
		<Row>
			<Col lg={3} className='text-center'>
				<Avatar
					src={team2}
					width={200}
					size='5xl'
					rounded='circle'
					className=' avatar-profile1'
					mediaClass='img-thumbnail shadow-sm'
				/>
			</Col>
			<Col lg={9}>
				<p className='modal-user-name'>{data['name_full'] ? data['name_full'] : pageLanguageContent['PRL033']}</p>
				<div className='modal-user-title'>
					<span className='title-text'>
						{pageLanguageContent['PRL077'] ? pageLanguageContent['PRL077'] : ''} :{' '}
						{pageLanguageContent['PRL078'] ? pageLanguageContent['PRL078'] : ''}
					</span>
					<div>
						<span className='title-text'>
							{' '}
							{pageLanguageContent['PRL079'] ? pageLanguageContent['PRL079'] : ''} : {data['id']}
						</span>
						<Badge
							bg={''}
							className='ml-2 user-copy-icon badge badge-soft-info'
							onClick={() => copyContent(data['id'])}
							data-toggle='tooltip'
							title={pageLanguageContent['PRL154'] ? pageLanguageContent['PRL154'] : ''}
						>
							<i className='far fa-copy'></i>
						</Badge>
					</div>
				</div>
				<UserProfileCardSection data={data} pageLanguageContent={pageLanguageContent} />
			</Col>
		</Row>
	);
};
export default UserProfileTopSection;
